import React, { useState } from 'react';
import { Check, XIcon } from 'lucide-react';
export function VerlatingsangstWebinarPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const listItems = ['Hoe je jouw hond in 5 stappen leert dat alleen thuis blijven niet spannend of vervelend is', 'De bekende en minder bekende symptomen van verlatingsangst en wat verschillende symptomen zeggen over de emoties die jouw hond ervaart wanneer jij niet in de buurt bent.', 'De verschillende oorzaken van verlatingsangst en hoe dit bepaald welke aanpak nodig is', 'Wat je in ieder geval NIET moet doen bij verlatingsangst (deze veel voorkomende adviezen verergeren de problemen!).', 'Praktijkvoorbeelden van hoe we verlatingsangst effectief in korte tijd vanuit de kern hebben opgelost'];
  const listItemsBottom = ['Hoe je jouw hond in 5 stappen leert dat alleen thuis blijven niet spannend of vervelend is waardoor je hond zich niet gestresst voelt als jij even weg bent.', 'De bekende en minder bekende symptomen van verlatingsangst en wat verschillende symptomen zeggen over de emoties die jouw hond ervaart wanneer jij niet in de buurt bent.', 'De verschillende oorzaken van verlatingsangst en hoe dit bepaald welke aanpak nodig is', 'Wat je in ieder geval NIET moet doen bij verlatingsangst (deze veel voorkomende adviezen verergeren de problemen!).', 'Praktijkvoorbeelden van hoe we verlatingsangst effectief in korte tijd vanuit de kern hebben opgelost'];
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-1817">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-1818">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-1819">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-1820">
              <XIcon className="w-6 h-6" data-id="element-1821" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-1822">
              <iframe src="https://app.webinargeek.com/embed/17321b1f-58a9-4c60-8a4c-57209064e3c1?cst=src-meta_cmp-va_pt-optin" height="550" width="330" title="Webinar Verlatingsangst" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-1823"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-1824">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-1825">
        <div className="flex justify-center md:justify-between items-center max-w-6xl mx-auto" data-id="element-1826">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-1827" />
          <div className="hidden md:block" data-id="element-1828">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-1829">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-1830">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-start" data-id="element-1831">
        <div className="md:col-span-7" data-id="element-1832">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4 text-center md:text-left" data-id="element-1833">
            Nu tijdelijk gratis te volgen: Webinar Verlatingsangst
          </p>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-[#1a2b4a] mb-6 leading-tight text-center md:text-left" data-id="element-1834">
            Leer hoe je verlatingsangst aanpakt via de Verlatingsangst
            Kernaanpak - zodat je hond ontspant wanneer jij even van huis gaat
          </h1>

          {/* Mobile-only embed form directly under headline */}
          <div className="md:hidden flex flex-col items-center mb-8" data-id="element-1835">
            <iframe src="https://app.webinargeek.com/embed/17321b1f-58a9-4c60-8a4c-57209064e3c1?cst=src-meta_cmp-va_pt-optin" height="550" width="330" title="Webinar Verlatingsangst" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-1836"></iframe>
            <p className="text-center text-sm text-gray-500 mt-4" data-id="element-1837">
              Iedereen ontvangt achteraf een opname in de mail.
            </p>
          </div>

          <p className="text-lg md:text-xl text-gray-700 mb-5 leading-relaxed font-medium text-center md:text-left" data-id="element-1838">
            Zonder bench, antiblafbanden, medicijnen of andere schadelijke
            oplossingen die de problemen alleen maar erger maken - zodat jij
            weer je vrijheid terug krijgt
          </p>

          <div className="flex items-center gap-3 mb-5 justify-center md:justify-start" data-id="element-1839">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-10 h-10 rounded-full object-cover flex-shrink-0" data-id="element-1840" />
            <span className="text-gray-700 font-medium text-sm" data-id="element-1841">
              Amee Buijs geeft dit webinar
            </span>
          </div>

          <div className="mb-8" data-id="element-1842">
            <p className="text-gray-800 mb-4 font-medium" data-id="element-1843">
              Tijdens dit gratis webinar leer je:
            </p>
            <ul className="space-y-4 mb-6" data-id="element-1844">
              {listItems.map((item, index) => <li key={index} className="flex items-start" data-id="element-1845">
                  <Check className="w-6 h-6 text-[#22c55e] mr-3 flex-shrink-0 mt-0.5" data-id="element-1846" />
                  <span className="text-gray-700 leading-relaxed" data-id="element-1847">{item}</span>
                </li>)}
            </ul>
            <p className="text-gray-700 font-medium mb-8" data-id="element-1848">
              Achteraf is er alle tijd voor vragen of om jouw situatie te
              bespreken
            </p>
            <div onClick={() => setIsPopupOpen(true)} className="bg-[#e6f7f5] p-4 rounded-lg border border-[#5ce0d2] text-center cursor-pointer hover:bg-[#d4f1ed] transition-colors" data-id="element-1849">
              <p className="font-bold text-[#1a2b4a] text-lg" data-id="element-1850">
                <span className="md:hidden" data-id="element-1851">
                  Doe mee op
                  <br data-id="element-1852" />
                  21 of 22 april om 13:00 uur
                </span>
                <span className="hidden md:inline" data-id="element-1853">
                  Doe mee op 21 of 22 april om 13:00 uur
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="hidden md:block md:col-span-5 self-start" data-id="element-1854">
          <div className="sticky top-8" data-id="element-1855">
            <div className="flex justify-center w-full" data-id="element-1856">
              <iframe src="https://app.webinargeek.com/embed/17321b1f-58a9-4c60-8a4c-57209064e3c1?cst=src-meta_cmp-va_pt-optin" height="550" width="330" title="Webinar Verlatingsangst" style={{
              border: 'none',
              borderRadius: '15px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-1857"></iframe>
            </div>
            <p className="text-center text-sm text-gray-500 mt-4" data-id="element-1858">
              Iedereen ontvangt achteraf een opname in de mail.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-[#f8f9fa] py-16 md:py-24" data-id="element-1859">
        <div className="max-w-6xl mx-auto px-4" data-id="element-1860">
          <h2 className="text-3xl font-bold text-center text-[#1a2b4a] mb-12" data-id="element-1861">
            Wat anderen zeggen
          </h2>
          <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-1862">
            {/* Testimonial 1 */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-1863">
              <div className="flex items-center gap-4 mb-6" data-id="element-1864">
                <img src="https://cdn.magicpatterns.com/uploads/mKoyAu9ct57WQsJZDv6NWS/freepik_facebook-profielfoto-onpr_2783654391.png" alt="Kim" className="w-16 h-16 rounded-full flex-shrink-0 object-cover" data-id="element-1865" />
                <div data-id="element-1866">
                  <h4 className="font-bold text-[#1a2b4a] text-lg" data-id="element-1867">Kim</h4>
                  <p className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1868">
                    HONDENOUDER
                  </p>
                </div>
              </div>
              <p className="text-gray-700 italic text-lg leading-relaxed" data-id="element-1869">
                "Rex is over het algemeen kalmer en we hebben oplossingen om
                naar buiten te kunnen gaan zonder dat hij de buurt bij elkaar
                jankt."
              </p>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-1870">
              <div className="flex items-center gap-4 mb-6" data-id="element-1871">
                <img src="https://cdn.magicpatterns.com/uploads/rABQQ2dVHdT3hgHeZfyygs/freepik_facebook-profielfoto-onpr_2783671693.png" alt="Margreet" className="w-16 h-16 rounded-full flex-shrink-0 object-cover" data-id="element-1872" />
                <div data-id="element-1873">
                  <h4 className="font-bold text-[#1a2b4a] text-lg" data-id="element-1874">Margreet</h4>
                  <p className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1875">
                    HONDENOUDER
                  </p>
                </div>
              </div>
              <p className="text-gray-700 italic text-lg leading-relaxed" data-id="element-1876">
                "bikkel is meer relaxed en rent niet steeds achter je aan naar
                de deur als je die kant op gaat. Hij kan gewoon alleen thuis
                blijven!!"
              </p>
            </div>
          </div>
          <p className="text-center text-gray-600 font-medium" data-id="element-1877">
            Iedereen ontvangt achteraf een opname in de mail.
          </p>
        </div>
      </section>

      {/* Over de sprekers */}
      <section className="py-16 md:py-24" data-id="element-1878">
        <div className="max-w-6xl mx-auto px-4" data-id="element-1879">
          <h2 className="text-3xl font-bold text-center text-[#1a2b4a] mb-16" data-id="element-1880">
            Gegeven door Amee & Sylvia
          </h2>
          <div className="grid md:grid-cols-2 gap-12" data-id="element-1881">
            {/* Spreker 1 */}
            <div className="text-center md:text-left flex flex-col items-center md:items-start" data-id="element-1882">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-48 h-48 rounded-full mb-6 shadow-md object-cover" data-id="element-1883" />
              <h3 className="text-2xl font-bold text-[#1a2b4a] mb-2" data-id="element-1884">Amee</h3>
              <p className="text-[#5ce0d2] font-bold mb-6" data-id="element-1885">
                Amee (eigenaar van Stressless Dogs)
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-1886">
                Als gediplomeerd hondengedragsdeskundige is het welzijn en het
                plezier van een hond, maar ook van zijn mens, het
                allerbelangrijkste! Ik werk daarom uitsluitend met methodes en
                middelen die vrij zijn van dwang, pijn, angst en straf. Vanuit
                mijn bedrijf StresslessDogs.nl heb ik in de afgelopen jaren al
                meer dan 15.000 hondenbaasjes en hun honden mogen helpen bij het
                versterken van hun band en het oplossen & voorkomen van
                problemen.
              </p>
            </div>

            {/* Spreker 2 */}
            <div className="text-center md:text-left flex flex-col items-center md:items-start" data-id="element-1887">
              <img src="https://cdn.magicpatterns.com/uploads/b8YJbHmWpw5J5Lb1ZJr8Yq/sylvia-en-pom-bankje-vierkant-350x350.webp" alt="Sylvia" className="w-48 h-48 rounded-full mb-6 shadow-md object-cover" data-id="element-1888" />
              <h3 className="text-2xl font-bold text-[#1a2b4a] mb-2" data-id="element-1889">Sylvia</h3>
              <p className="text-[#5ce0d2] font-bold mb-6" data-id="element-1890">
                Sylvia (verlatingsangst expert)
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-1891">
                Mijn naam is Sylvia. Ik ben al vele jaren werkzaam als
                gedragstherapeute voor honden. Dit is niet alleen mijn
                fulltimebaan, het is ook mijn hobby en grote passie. Ik ben
                gespecialiseerd in honden met verlatingsangst en heb hiermee al
                honderden hondenbaasjes geholpen met de verlatingsangst van hun
                honden. Hierdoor kunnen vele baasjes weer ontspannen van huis
                zonder dat hun hond begint te janken, blaffen of in paniek
                raakt.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-[#f8f9fa] py-16 md:py-24" data-id="element-1892">
        <div className="max-w-4xl mx-auto px-4" data-id="element-1893">
          <h2 className="text-3xl font-bold text-center text-[#1a2b4a] mb-12" data-id="element-1894">
            Veel gestelde vragen:
          </h2>
          <div className="space-y-6" data-id="element-1895">
            {[{
            q: 'Hoelang duurt het?',
            a: 'Het hele webinar duurt 90 minuten. Blok deze tijd dus in je agenda!'
          }, {
            q: 'Kan ik het terugkijken?',
            a: 'Dat kan zeker! Iedereen die zich aanmeldt ontvangt achteraf een herhaling in de mail. Kan je dus niet op een van de data dan kan je jezelf alsnog aanmelden zodat je achteraf de herhaling ontvangt.'
          }, {
            q: 'Ik weet niet zeker of mijn hond verlatingsangst heeft',
            a: 'We bespreken de verschillende symptomen van verlatingsangst. Na het webinar weet je zeker of jouw hond verlatingsangst heeft en wat eventueel in jullie situatie de oplossing is.'
          }, {
            q: 'Word er iets verkocht?',
            a: 'Het webinar bestaat uit 90 minuten aan waardevolle informatie over hoe honden communiceren en misvatting die je nu waarschijnlijk hebt. Als je na deze 90 minuten nog meer wilt leren over dit onderwerp dan doe ik je een aanbod. Ook zonder dit aanbod is het webinar waardevol en je hebt het aanbod ook niet nodig om verder te werken aan de relatie met je hond. Maar ik geloof er in dat het aanbod erg waardevol is en het is dan ook een unieke kans om de allerbeste relatie met hun hond te ontwikkelen.'
          }, {
            q: 'Ik heb achteraf nog een vraag, kan ik die dan nog stellen?',
            a: 'Ja! Stuur een mailtje naar amee@stresslessdogs.nl en dan probeer ik zo snel mogelijk een antwoord te geven op je vraag.'
          }].map((faq, i) => <div key={i} className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-1896">
                <h4 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-1897">
                  {faq.q}
                </h4>
                <p className="text-gray-700 leading-relaxed" data-id="element-1898">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-16 md:py-24" data-id="element-1899">
        <div className="max-w-4xl mx-auto px-4" data-id="element-1900">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-gray-100 text-center" data-id="element-1901">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6" data-id="element-1902">
              Webinar Verlatingsangst
            </h2>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-1903">
              Na dit webinar weet je precies wat ervoor nodig is om je hond
              zorgeloos thuis te kunnen laten zodat je met een gerust hart ook
              nog je eigen leven kan leiden. Tijdens dit gratis webinar leer je:
            </p>

            <div className="text-left max-w-2xl mx-auto mb-10" data-id="element-1904">
              <ul className="space-y-4 mb-6" data-id="element-1905">
                {listItemsBottom.map((item, index) => <li key={index} className="flex items-start" data-id="element-1906">
                    <Check className="w-6 h-6 text-[#22c55e] mr-3 flex-shrink-0 mt-0.5" data-id="element-1907" />
                    <span className="text-gray-700 leading-relaxed" data-id="element-1908">
                      {item}
                    </span>
                  </li>)}
              </ul>
              <p className="text-gray-700 font-medium" data-id="element-1909">
                Achteraf is er alle tijd voor vragen of om jouw situatie te
                bespreken
              </p>
            </div>

            <button onClick={() => setIsPopupOpen(true)} className="bg-[#22c55e] hover:bg-[#16a34a] text-white font-bold py-4 px-10 rounded-xl text-xl transition-colors shadow-lg w-full md:w-auto" data-id="element-1910">
              Meld je gratis aan
            </button>
            <p className="text-gray-500 mt-6 font-medium" data-id="element-1911">
              Iedereen ontvangt achteraf een opname in de mail.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a2b4a] text-white py-12" data-id="element-1912">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-1913">
          <p className="mb-4 text-sm text-gray-300" data-id="element-1914">
            © Copyright Stressless Dogs | stresslessdogs.nl | Alle rechten
            voorbehouden
          </p>
          <p className="mb-4 text-sm text-gray-400 leading-relaxed" data-id="element-1915">
            Deze website maakt geen onderdeel uit van Facebook of Facebook Inc.
            Deze site is op geen enkele manier gelinkt aan Facebook. Facebook is
            een handelsnaam van Facebook Inc.
          </p>
          <p className="text-sm text-gray-300" data-id="element-1916">
            vragen kun je altijd stellen door te mailen naar{' '}
            <a href="mailto:amee@stresslessdogs.nl" className="text-[#5ce0d2] hover:underline" data-id="element-1917">
              amee@stresslessdogs.nl
            </a>
          </p>
        </div>
      </footer>
    </div>;
}